// extracted by mini-css-extract-plugin
export var container = "SMnVl";
export var content = "y-Wtk";
export var metaKey = "mH-kx";
export var metaList = "g7m9T";
export var metaRow = "ODrRO";
export var metaValue = "FVmmQ";
export var root = "+1vx0";
export var text = "_42Rnc";
export var title = "xctsz";